import Globe from './svg/Globe'
import Youtube from './svg/Youtube'
import Instagram from './svg/Instagram'
import Email from './svg/Email'
import Facebook from './svg/Facebook'
import Linkedin from './svg/Linkedin'
import Pinterest from './svg/Pinterest'
import Gb from './svg/Gb'
import Ru from './svg/Ru'
import Pt from './svg/Pt'

export default {
    'globe': Globe,
    'youtube': Youtube,
    'instagram': Instagram,
    'email': Email,
    'facebook': Facebook,
    'linkedin': Linkedin,
    'pinterest': Pinterest,
	'en': Gb,
	'ru': Ru,
	'pt': Pt
}
